<div mat-dialog-title>
  <h2>
    {{ (recordId || isOurProfile || isOurProfileVl ? 'labProfile.update' : 'labProfile.add')|translate }}
    {{"general.restaurant"|translate}}
    {{( data.addBranch ? 'labProfile.branch' : '')|translate }}
  </h2>
  <button type="button" class="close" mat-dialog-close aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">
    <form [formGroup]="formGroup">

      <div class="fields-group">

        <mat-form-field>
          <mat-label>{{"labs.restaurantName"|translate}}</mat-label>
          <input matInput formControlName="Lab" maxlength="100">
          <mat-error *ngIf="hasError('Lab', 'required')">{{ 'forms.Required' | translate }}</mat-error>
          <mat-error *ngIf="hasError('Lab', 'notUniqe')">{{"forms.restaurantNameAlreadyExist"|translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="fields-group mb-5">
        <div class="upload-logo">
          <div class="image-upload">
            <label for="imageUpload">
              <input type='file' class="img-viewer" id="imageUpload" accept="image/jpeg, image/pjpeg, image/png"
                (change)="changeFileListener($event)">
              <div class="image-preview">
                <img [src]="logoSrc" *ngIf="logoSrc">
              </div>
              <span class="plus-icon"></span>
            </label>
          </div>
          <div>
            <label>{{ 'forms.Upload photo' | translate }}</label>
            <p>{{ 'forms.Maximumfilesize2MB' | translate }} <br>
              {{ 'forms.Werecommendimagedimensions' | translate }}</p>
          </div>
        </div>
        <p class="invalid-feedback mt-2 d-block" *ngIf="!logoSrc && isSubmitted">{{ 'forms.Required' | translate }}</p>
        <p class="invalid-feedback mt-2 d-block" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p>
        <p class="invalid-feedback mt-2 d-block" *ngIf="fileSizeError">{{ 'forms.Max-files' | translate }}
          {{maxFileSize}} Mb</p>
      </div>

      <div class="fields-group">
        <h3 class="fields-title">{{"labProfile.contactsInfo"|translate}}</h3>

        <div class="form-group">
          <ngx-intl-tel-input [customPlaceholder]="''" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
            [maxLength]="50" [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true"
            [searchCountryField]="[SearchCountryField.All]" [searchCountryFlag]="true" [selectFirstCountry]="false"
            [selectedCountryISO]="selectedCountryISO" [separateDialCode]="true" formControlName="contactNumber"
            name="contactNumber">
          </ngx-intl-tel-input>
          <p class="has-error" *ngIf="
              formGroup.controls['contactNumber'].errors &&
              formGroup.controls['contactNumber'].errors['required'] && isSubmitted">{{ 'forms.Required' | translate }}
          </p>

          <p class="has-error" *ngIf="
              formGroup.controls['contactNumber'].errors &&
              formGroup.controls['contactNumber'].errors['validatePhoneNumber'] ">
            {{"labProfile.enterValidNumberAccordingSelectedCountry"|translate}}
          </p>
        </div>

        <mat-form-field>
          <mat-label>{{"general.emailAddress"|translate}}</mat-label>
          <input matInput formControlName="email" maxlength="50" (cdkAutofill)="autoFillInput('email')">
          <mat-error *ngIf="hasError('email', 'required')">{{ 'forms.Required' | translate }}</mat-error>
          <mat-error *ngIf="hasError('email', 'invalid')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          <mat-error *ngIf="hasError('email', 'pattern')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="fields-group">
        <h3 class="fields-title">{{"general.address"|translate}}</h3>

        <mat-form-field>
          <mat-label>{{"general.country"|translate}}</mat-label>
          <mat-select disableOptionCentering formControlName="country" (selectionChange)='getRegions(true)'>
            <mat-option [value]="item.id" *ngFor="let item of countryList">
              <span>{{item.name}}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('country', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"general.regionGovernorateEmirate"|translate}}</mat-label>
          <mat-select disableOptionCentering formControlName="region" (selectionChange)='getCities(true)'>
            <mat-option [value]="item.id" *ngFor="let item of regionList">
              <span>{{item.name}}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('region', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"general.city"|translate}}</mat-label>
          <mat-select disableOptionCentering formControlName="cityId">
            <mat-option [value]="item.id" *ngFor="let item of cityList">
              <span>{{item.name}}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('cityId', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"general.streetAddress"|translate}}</mat-label>
          <textarea matInput formControlName="address" maxlength="500"></textarea>
          <mat-error *ngIf="hasError('address', 'required')">{{ 'forms.Required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <button class="w-100" mat-raised-button color="primary" [disabled]="loading" [class.loading]='loading'
        (click)="saveRecord()">
        {{( recordId || isOurProfile || isOurProfileVl ? 'labProfile.update' : 'labProfile.add' )|translate}}
        {{"general.restaurant"|translate}}
      </button>
    </form>
  </div>
</mat-dialog-content>